import { StrictMode, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './styles/theme.css';
import './styles/app.css';
// Importing the auth store here (not lazily) registers the token bridge with the
// API client before the first request can leave.
import '@/lib/auth';
import { router } from '@/app/router';
import { AvisoDeAtualizacao } from '@/components/PwaBits';
import { registrarServiceWorker } from '@/lib/pwa';

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado no index.html.');

/**
 * O aviso de atualização vive acima do router porque uma versão nova pode chegar
 * em qualquer rota, e trocar de tela não deve fazê-lo sumir.
 */
function App() {
  const [aplicarAtualizacao, setAplicarAtualizacao] = useState<(() => void) | null>(null);

  return (
    <>
      <AvisoDeAtualizacao aplicar={aplicarAtualizacao} />
      <RouterProvider router={router} />
      <RegistroDoServiceWorker onAtualizacao={setAplicarAtualizacao} />
    </>
  );
}

/**
 * Registra o worker uma única vez.
 *
 * Em componente separado, e não num efeito do `App`, porque o StrictMode monta e
 * desmonta os efeitos duas vezes em desenvolvimento — e registrar duas vezes
 * dispara dois `updatefound` para a mesma instalação.
 */
let registrado = false;
function RegistroDoServiceWorker({
  onAtualizacao,
}: {
  onAtualizacao: (aplicar: () => void) => void;
}) {
  if (!registrado) {
    registrado = true;
    // `() => aplicar` porque o setState de React trata função como atualizador:
    // passar `aplicar` cru faria o React chamá-la imediatamente e recarregar a
    // página sem perguntar nada.
    registrarServiceWorker((aplicar) => onAtualizacao(() => aplicar));
  }
  return null;
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
